export const buildLogisticTableActionDetails = (rowData = {}) => ({
  labelId: rowData.customer_PO_Number,
  valueName: rowData.customer_PO_Number,
  SapOrderNumber: rowData.sap_Order_Number,
  bL_Number: rowData.bL_LR_Number || rowData.bL_Number || "",
  container_Number: rowData.container_Number || "",
  status: rowData.status || "",
  distribution_Channel: rowData.distribution_Channel || "",
  customer_PO_Date: rowData.customer_PO_Date || "",
  dispatch_Actual: rowData.dispatch_Actual || "",
});
